import {
  FormikInput,
  Link,
  Stack,
  Typography,
  Alert,
  useResponsive,
  useTheme,
  LoadingButton,
  numberUtils
} from '@rabex-kit/rabex-ui';
import { Form, Formik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { InfoCircle } from 'iconsax-react';
import useInAppLink from '@/hooks/useInAppLink';
import Arrow from '../../static/images/svg/Controls.svg';
import Mobile from '../../static/images/svg/Mobile.svg';
import { ForgetFormT } from './types';
import { LOGIN } from '../../pages/routes';
import { emailRegex, mobileRegex } from '../Login';
import { ClearButton } from '../AuthIconButton';

export type ForgetProps = {
  initialValues: ForgetFormT;
  isLoading: boolean;
  onSubmit: (values: { username: string | number }) => void;
};

const ForgetForm: React.FC<ForgetProps> = ({
  initialValues,
  onSubmit,
  isLoading
}) => {
  const inAppLink = useInAppLink();
  const { matches } = useResponsive();
  const theme = useTheme();

  const validationSchema = yup.object({
    username: yup
      .string()
      .required('ایمیل یا شماره موبایل الزامی است.')
      .transform((value) => numberUtils.toEn(value))
      .test(
        'valid-email-or-mobile',
        'لطفاً یک ایمیل معتبر یا شماره موبایل وارد کنید.',
        (value) => {
          if (!value) return false;
          return (
            emailRegex.test(value.trim()) || mobileRegex.test(value.trim())
          );
        }
      )
  });

  return (
    <Stack
      gap={0}
      width={{ xs: '100%', lg: 464 }}
      mt={{ lg: 5, xs: 0 }}
      zIndex={2}>
      <Link
        mb={3}
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
        {...inAppLink(LOGIN)}
        fontWeight="600"
        color={theme.palette.textColor[900]}
        sx={{ textDecoration: 'none' }}
        variant={matches({ xs: 'body3', lg: 'body2' })}>
        <Stack direction="row" gap={0} alignItems="center">
          <img src={Arrow} alt="" style={{ width: 24, height: 24 }} />
          {/* <Typography variant="body2" weight="bold"> */}
          {/*  انصراف */}
          {/* </Typography> */}
        </Stack>
      </Link>
      <Typography
        mb={{ lg: 6, xs: 2 }}
        variant={matches({ lg: 'subtitle', xs: 'body1' })}
        weight="bold">
        بازیابی رمز عبور
      </Typography>
      <Alert
        variant="filled"
        color="warning"
        icon={
          <InfoCircle
            size="24"
            color={theme.palette.warning[400]}
            variant="Bold"
          />
        }
        sx={{ mb: matches({ xs: 3, lg: 6 }) }}>
        <Typography
          variant={matches({ xs: 'body3', lg: 'body2' })}
          weight="bold">
          کاربر گرامی برای حفظ امنیت، تا ۲۴ساعت بعد از تغییر رمز، امکان برداشت
          از حساب مقدور نمی‌باشد.
        </Typography>
      </Alert>
      <Formik
        // Validation already reads the number in ASCII digits; send it that way too.
        onSubmit={(val) =>
          onSubmit({
            ...val,
            username: numberUtils.toEn(String(val.username)).trim()
          })
        }
        validationSchema={validationSchema}
        initialValues={{
          username: initialValues.username
        }}>
        {(formik) => (
          <Form>
            <Stack gap={4}>
              <FormikInput
                placeholder="شماره همراه یا ایمیل"
                name="username"
                endAdornment={
                  <>
                    {formik.values.username && (
                      <ClearButton
                        onClick={() => formik.setFieldValue('username', '')}
                      />
                    )}
                    <img src={Mobile} alt="" aria-hidden />
                  </>
                }
              />
              <LoadingButton
                size={matches({ xs: 'md', lg: 'lg' })}
                fullWidth
                variant="contained"
                loading={isLoading}
                type="submit"
                disabled={!formik.values.username}
                /* color={formik.values.username !== '' ? 'primary' : 'info'} */
              >
                ادامه
              </LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </Stack>
  );
};

export default ForgetForm;
